import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipment-types',
  templateUrl: './shipment-types.component.html',
  styleUrls: ['./shipment-types.component.scss']
})
export class ShipmentTypesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
